// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2KM8s","title":"card_title__2ZLE3","inActive":"card_inActive__2PgDb"};